import React, { useState, useMemo, useEffect , useRef} from 'react';
import Element from './Elements/Element';
import '../../css/AddTripForm/Variant.css';
import { useTripContext } from '../Trips/TripContext';
import { useUser } from '../userContext';
import FormField from './FormField';
import {validateVariantInputs} from "./validateInputs";
import {formatDateWithTime} from '../Common/dateManager';
import Select from 'react-select';
import { userAPI } from '../../api/apiClient';
import useApi from '../CustomHooks/useApi';
import { useToast } from '../../Contexts/ToastContext';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import {getSuggestedCancellationDate, getSuggestedCancellationInfoText} from "../../utils/cancellationHelper.js";

const difficultyLevels = [
  { value: 1, label: "🟢 Łatwa" },
  { value: 2, label: "🟡 Łatwa/średnia" },
  { value: 3, label: "🟠 Średnio wymagająca" },
  { value: 4, label: "🔴 Wymagająca" },
  { value: 5, label: "⚫ Bardzo trudna" },
];

const tripTypes = [
  { value: 1, label: "🪶 Na lekko" },
  { value: 2, label: "🥾 Wędrowna z plecakiem" },
  { value: 3, label: "🛶 Spływ kajakowy" },
]

function formatDateOnly(dateTimeString) {
  return dateTimeString?.split('T')[0];
}

const tripTypesDescriptions = [
  "Do plecaka na szlak zabieramy tylko niezbędne rzeczy, czyli wodę, przekąski, coś od deszczu i słońca oraz ewentualnie inne niezbędne rzeczy wskazane przez osobę koordynującą wycieczkę.",
  "Do plecaka zabieramy wszystkie niezbędne rzeczy, w tym ubrania i jedzenie i maszerujemy z nimi przez kilka dni.",
  "Spływ kajakowy",
]
const difficultyTypesDescriptions = [
  [
    "To idealna trasa dla osób, które chcą przetestować swoje umiejętności chodzenia po górach, albo wracają w góry po dłuższej przerwie.",
    "Tę wycieczkę polecamy osobom, które znają swoje możliwości. Wybrany przez nas szlak nie będzie trudny technicznie, ale nie jest to propozycja na Twój pierwszy raz z górami.",
    "Ze względu na długość trasy, ekspozycję albo niewielkie trudności techniczne oznaczamy tę wycieczkę jako średnio wymagającą. Sprawdź szczegóły, porównaj ze swoimi poprzednimi doświadczeniami i zdecyduj, czy jest to trasa dla Ciebie",
    "Jest to wycieczka dla osób, które mają doświadczenie w chodzeniu po górach. Nie straszne są Ci dłuższe trasy, łańcuchy czy ekspozycja. Szczegóły znajdziesz w opisie.", 
    "Nie boisz się przewyższeń i kilometrów, a łańcuchy i inne zabezpieczenia nie robią na Tobie wrażenia? To jest trasa dla Ciebie."
  ],
  [
    "Jeżeli chodzisz regularnie po górach “na lekko” i chcesz spróbować pierwszy raz przejść trasę z cięższym plecakiem, jest to propozycja dla Ciebie.",
    "Tę wycieczkę polecamy osobom, które znają swoje możliwości. Wybrany przez nas szlak nie będzie trudny technicznie, ale nie jest to propozycja na Twój pierwszy raz z górami. Pamiętaj, że wszystkie rzeczy musisz nieść w swoim plecaku.", 
    "Ze względu na długość trasy oznaczamy tę wycieczkę jako średnio wymagającą. Sprawdź szczegóły, porównaj ze swoimi poprzednimi doświadczeniami i zdecyduj, czy jest to trasa dla Ciebie. Zapraszamy osoby, które chodziły już z cięższym plecakiem po górach.", 
    "Jest to wycieczka dla osób, które mają doświadczenie w chodzeniu po górach z plecakiem. Nie straszne są Ci dłuższe trasy, zabezpieczenia albo ekspozycja. Szczegóły znajdziesz w opisie.", 
    "Nie boisz się przewyższeń i kilometrów, a łańcuchy i inne zabezpieczenia nie robią na Tobie wrażenia? To jest trasa dla Ciebie. Trudności na szlaku sprawdzisz w opisie." 
  ],
  [
    "---", 
    "---", 
    "---",
    "---", 
    "---" 
  ]
];


const Variant = ({ onSave, onDelete, onUpdate, onUpdateElement, initialData }) => {
  const { tripData, deleteVariant,   selectedVariantGuid, addVariant, updateVariant} = useTripContext();
  const { user } = useUser();
  const {showToast, clearToast} = useToast();
  const selectedVariant = tripData?.variants.find(
    variant => variant.guid === selectedVariantGuid
);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); 
  const [variantData, setVariantData] = useState(
    selectedVariant || initialData || {
      name: null,
    variantPhoto: null,
    variantPhotoLink: null,
    variantPhotoThumbnailLink: null,
    variantPhotoSource: null,
    coordinators: [],
    primaryCoordinator: null,
    startDate: null,
    endDate: null,
    description: null,
    place: null,
    transport: null,
    questionAboutCars: false,
    isTouristEvent: false,
    isTripAbroad: false,
    askAboutNNW: false,
    prepaymentPercentage: 100,
    priceIncludes: null,
    priceNotIncludes: null,
    petsInfo: null,
    additionalInfo: null,
    languageRequirements: null,
    requiredDocuments: null,
    placeOrShortened: null,
    cancelationTripFinalDate: null,
    minRegistrationsNumber: null,
    insurance: null,
    tfgContribution: 4,
    nnwContribution: null,
    askAboutFoodOptions: false,
    foodInfo: null,
    administrativeCosts: 6.0,
    difficultyLevel: null,
    difficultyLevelDescription: null,
    tripType: null,
    tripTypeDescription: null,
    destinationCountry: null,
    borderCrossingOutboundDate: null,
    borderCrossingReturnDate: null,
    ccPrimaryCoordinatorInEmails: false,
    nnwRateType: null
    }
  );

  const [showElementInForm, setShowElementInForm] = useState(false);
  const [clickedElement, setClickedElement] = useState(null);
  const formRef = useRef(null);
  const [availableCoordinators, setCoordinatorsList] = useState([]);
  const { callApi, isLoading: isLoadingCoordinators } = useApi();
  const [showElementCreationChoice, setShowElementCreationChoice] = useState(false);
const [expandedCopyGroup, setExpandedCopyGroup] = useState(null);
const [areDetailsCollapsed, setAreDetailsCollapsed] = useState(false);

const variantTitle = useMemo(() => {
  return variantData?.name || "Nowy wariant";
}, [variantData?.name, variantData?.startDate]);


useEffect(() => {
  callApi(
    () => userAPI.getUsers(["Coordinator"]),
    (data) => setCoordinatorsList(data)
  );
}, []);


  

const groupedElementsByDay = useMemo(() => {
  const elements = tripData.elements
    .filter((element) => element.variants.includes(variantData.guid))
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

  const groups = {};

  elements.forEach((el) => {
    const rawKey = format(new Date(el.startDate), 'EEEE, dd.MM.yyyy', { locale: pl }); 
    const dayKey = rawKey.charAt(0).toUpperCase() + rawKey.slice(1); 
    if (!groups[dayKey]) groups[dayKey] = [];
    groups[dayKey].push(el);
  });

  return groups;
}, [tripData.elements, variantData.guid]);

const variantElements = useMemo(() =>
  tripData?.elements?.filter(el => el.variants.includes(variantData.guid)) || [],
[tripData.elements, variantData.guid]);

const variantElementsTotal = useMemo(() =>
  variantElements.reduce((sum, el) => sum + Number(el.pricePerPerson ?? 0), 0),
[variantElements]);

const additionalCosts = useMemo(() =>
  Number(variantData.administrativeCosts ?? 0) +
  (variantData.isTouristEvent ? Number(variantData.tfgContribution ?? 0) : 0) +
  (variantData.isTouristEvent && variantData.isTripAbroad ? Number(variantData.nnwContribution ?? 0) : 0),
[variantData]);

const fullPrice = useMemo(() =>
  Number((variantElementsTotal + additionalCosts).toFixed(2)),
[variantElementsTotal, additionalCosts]);

const prepaymentAmount = useMemo(() => {
  const ratio = (variantData.prepaymentPercentage ?? 100) / 100;
  return Number((variantElementsTotal * ratio + additionalCosts).toFixed(2));
}, [variantElementsTotal, variantData.prepaymentPercentage, additionalCosts]);

const resignationInsuranceAmount = useMemo(() =>
  Number(((variantElementsTotal + (variantData.administrativeCosts ?? 0)) * 0.022).toFixed(2)),
[variantElementsTotal, variantData.administrativeCosts]);


  const primaryCoordinatorOptions = useMemo(() => {
    return variantData.coordinators.map(c => ({
      value: c.id,
      label: `${c.name} (${c.email})`,
    }));
  }, [variantData.coordinators]);

  const handleCoordinatorUpdate = (updatedCoordinators) => {
    setVariantData((prev) => {
      const updatedData = { ...prev, coordinators: updatedCoordinators };
  
      if (!updatedCoordinators.some(c => c.id === prev.primaryCoordinatorId)) {
        updatedData.primaryCoordinatorId = null;
      }
  
      return updatedData;
    });
  };

const toggleCopyGroup = (variantName) => {
  setExpandedCopyGroup(prev => (prev === variantName ? null : variantName));
};


  const handleChange = (field, value) => {
    if (value === null || value === undefined || value === "" || value.trim?.() === "") {
      value = null;
    }
    else if (typeof value === "boolean") {

    }
    else if (!isNaN(value)) {
      value = Number(value);
    }

    setVariantData((prev) => {
      const updatedData = { ...prev, [field]: value };
      if (field === "tripType" && value === null) {
        updatedData.tripTypeDescription = null;
      }

      if (field === "difficultyLevel" && value === null) {
        updatedData.difficultyLevelDescription = null;
      }

      if (field === "primaryCoordinatorId" && value === null) {
        updatedData.ccPrimaryCoordinatorInEmails = false;
      }

      switch (field) {
        case "isTouristEvent":
          if (value === false) {
            updatedData.tfgContribution = null;
            updatedData.askAboutNNW = false;
            updatedData.nnwContribution = null;
            updatedData.destinationCountry = null;
            updatedData.borderCrossingOutboundDate = null;
            updatedData.borderCrossingReturnDate = null;
            updatedData.nnwResignationCostContribution = null;
            updatedData.minRegistrationsNumber = null;
            updatedData.shortenedPlaceName = null;
            updatedData.languageRequirements = null;
            updatedData.requiredDocuments = null;
            updatedData.peopleWithDisabilitiesInfo = null;
            updatedData.insuranceDetails = null;
            updatedData.priceIncludes = null;
            updatedData.priceNotIncludes = null;
            updatedData.cancelationTripFinalDate = null;
            updatedData.nnwRateType = null
          }
          break;
        case "askAboutNNW":
          if (value === false) {
            updatedData.nnwContribution = null;
          }
          break;
        case "isTripAbroad":
          if (value === false) {
            updatedData.destinationCountry = null;
            updatedData.borderCrossingOutboundDate = null;
            updatedData.borderCrossingReturnDate = null;
            updatedData.askAboutNNW = false;
            updatedData.nnwContribution = null;
            updatedData.nnwRateType = null;
          }
          break;
        case "askAboutFoodOptions":
          if (value === false) {
            updatedData.foodInfo = null;
          }
          break;
      }
  
      return updatedData;
    });
  };

  const saveElement = async () => {
     setShowElementInForm(false);
     setClickedElement(null);
    await onUpdateElement();
  };

  const onClickDeleteElement = async () => {
    setShowElementInForm(false);
    setClickedElement(null);
    await onUpdateElement();
  };

  const cancelElement = () => {
    setClickedElement(null);
    setShowElementInForm(false);
  };

  const handleEditElement = (element) => {
    setClickedElement(element);
    setShowElementInForm(true);
  };

  const getElementsGroupedByVariant = () => {
  const elementsByVariant = {};

  tripData.variants.forEach((variant) => {
    const elements = tripData.elements.filter((element) =>
      element.variants.includes(variant.guid)
    );
    if (elements.length > 0) {
      elementsByVariant[variant.name] = elements;
    }
  });

  return elementsByVariant;
};


const handleAddElement = () => {
  setShowElementCreationChoice(true);
};

  const handleSaveVariant = async () => {
    setIsSaving(true);
    if (!validateVariantInputs(formRef)) {
      setIsSaving(false);
      return;
    }


    showToast("Zapisywanie wariantu...", 'processing');
    try {
      if (variantData.guid)
      {
        await updateVariant(variantData);
        onUpdate(variantData);
      }
      else
      {
        await addVariant(tripData.guid, variantData);
        onSave(variantData); 
      }
    } catch (error) {
      console.error("Błąd podczas zapisywania wariantu:", error);
    } finally {
      setIsSaving(false); 
      clearToast();
    }
  };

  const handleDeleteVariant = async () => {
    if (window.confirm('Czy na pewno chcesz usunąć ten wariant?')) {
      setIsDeleting(true); 
      try {
        showToast('Usuwanie wariantu...', 'processing')
        await deleteVariant(variantData.guid);
        onDelete();
      } catch (error) {
        console.error("Błąd podczas usuwania wariantu:", error);
      } finally {
        setIsDeleting(false); 
        clearToast();
      }
      onDelete();
    }
   
  };

  const handleDiscardChanges =  () => {
    if (window.confirm('Czy na pewno chcesz porzucić wprowadzone zmiany?')) {
      onDelete();
    }
   
  };
  const typeIcons = {
    0: <i className="fas fa-landmark" title="Atrakcja"></i>,
    1: <i className="fas fa-bed" title="Nocleg"></i>,
    2: <i className="fas fa-car" title="Transport indywidualny"></i>,
    3: <i className="fas fa-bus" title="Transport zbiorowy"></i>,
    4: <i className="fas fa-hiking" title="Trekking"></i>,
  };

  const findMinCapacityByVariant = useMemo(() => {
    const filteredElements = tripData.elements.filter((element) =>
      element.isWithLimitedPlaces === true &&
      element.variants.some((variantGuid) => variantGuid === variantData.guid)
    );
    const capacities = filteredElements.map((element) => Number(element.capacity));
    return capacities.length > 0 ? Math.min(...capacities) : "--- Wariant bez limitu miejsc ---";
  }, [tripData.elements, variantData.guid]);

  return (
    <div className="variantContainer" ref={formRef}>

    <div className="variantStickyHeader">
      <div className="variantStickyLeft">
        <div className="variantStickyTitle">{variantTitle}</div>
        <div className="variantStickySubtitle">
          {selectedVariantGuid ? "Edycja wariantu" : "Dodawanie wariantu"}
        </div>
      </div>

      <div className="variantStickyRight">
        <button
          type="button"
          className="variantCollapseBtn"
          onClick={() => {
              setAreDetailsCollapsed((prev) => {
                const next = !prev;
                if (prev === true && next === false) {
                  requestAnimationFrame(() => {
                    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                  });
                }

                return next;
              });
            }}
        >
           <i className={`fas ${areDetailsCollapsed ? "fa-chevron-down" : "fa-chevron-up"}`} />
        </button>
      </div>
    </div>
    <div className="variantStickySpacer" />

{!areDetailsCollapsed && (
  <>      
      <FormField
        label="Nazwa wariantu"
        name="name"
        type="text"
        value={variantData.name}
        onChange={handleChange}
        placeholder="Wpisz nazwę wariantu"
        required
      />
      <FormField
        label="Zdjęcie"
        name="variantPhoto"
        photoLinkName="variantPhotoLink"
        photoSourceName="variantPhotoSource"
        type="file"
        value={variantData.variantPhotoLink}
        onChange={handleChange}
      />
       <FormField
        label="Źródło zdjęcia"
        name="variantPhotoSource"
        value={variantData.variantPhotoSource || ""}
        onChange={handleChange}
        placeholder={
          (variantData.variantPhoto === null || variantData.variantPhoto === undefined) && (variantData.variantPhotoLink === null)
            ? "--- Nie wybrano zdjęcia ---"
            : "Podaj źródło zdjęcia"
        }
        disabled={(variantData.variantPhoto === null || variantData.variantPhoto === undefined) && (variantData.variantPhotoLink === null)}
      />
<FormField
  label="Typ wycieczki"
  type="label"
/>
  <Select
    options={tripTypes}
    value={tripTypes.find(opt => opt.value === variantData.tripType) || ""}
    onChange={(selected) =>
      handleChange("tripType", selected ? selected.value : null) 
    }
    isClearable
    placeholder="Wybierz typ wycieczki"
    isSearchable
    styles={{
      container: (base) => ({
        ...base,
        width: "100%" 
      }),
      control: (base) => ({
        ...base,
        width: "100%",
        marginTop: "-20px",
        marginBottom: "20px"
      })
    }}
  />


{variantData.tripType !== null && (
  <FormField
    label="Opis typu wycieczki"
    name="tripTypeDescription"
    type="richtext"
    value={variantData.tripTypeDescription}
    predefinedValues={[tripTypesDescriptions[variantData.tripType - 1]]}
    onChange={handleChange} 
  />
)}

<FormField
  label="Poziom trudności"
  type="label"
/>
  <Select
    options={difficultyLevels}
    value={difficultyLevels.find(opt => opt.value === variantData.difficultyLevel) || ""}
    onChange={(selected) =>
      handleChange("difficultyLevel", selected ? selected.value : null) 
    }
    isClearable
    placeholder="Wybierz poziom trudności"
    isSearchable
    styles={{
      container: (base) => ({
        ...base,
        width: "100%" 
      }),
      control: (base) => ({
        ...base,
        width: "100%",
        marginTop: "-20px",
        marginBottom: "20px" 
      })
    }}
  />


{variantData.difficultyLevel !== null && (
  <FormField
    label="Opis poziomu trudności"
    name="difficultyLevelDescription"
    type="richtext"
    value={variantData.difficultyLevelDescription}
    predefinedValues={
      (() => {
        const description = difficultyTypesDescriptions[variantData.tripType - 1]?.[variantData.difficultyLevel - 1];
        return description ? [description] : undefined;
      })()
    }
    onChange={handleChange} 
  />
)}
       <FormField
       type="coordinators"
       label="Osoby koordynujące"
       value={variantData.coordinators}
       coordinators={availableCoordinators}
        onChange={handleCoordinatorUpdate}
        loading={isLoadingCoordinators}
        required
      />
      <FormField type="label" label="Osoba kontaktowa" required />
      <Select
        options={primaryCoordinatorOptions}
        value={primaryCoordinatorOptions.find(opt => opt.value === variantData.primaryCoordinatorId) || ""}
        onChange={(selected) =>
          handleChange("primaryCoordinatorId", selected ? selected.value : null)
        }
        isClearable
        placeholder="Wybierz główną osobę kontaktową"
        isSearchable
        styles={{
          container: (base) => ({
            ...base,
            width: "100%" 
          }),
          control: (base) => ({
            ...base,
            width: "100%",
            marginTop: "-20px",
            marginBottom: "20px" 
          })
        }}
      />

      {variantData.primaryCoordinatorId && (
        <FormField
          label="Wysyłać kopię maili automatycznych osobie kontaktowej?"
          name="ccPrimaryCoordinatorInEmails"
          type="toggle"
          value={variantData.ccPrimaryCoordinatorInEmails}
          onChange={handleChange}
          info="Wszystkie maile automatyczne widoczne są w systemie. Zaznacz aby otrzymywać je również na swój adres email."
        />
      )}

      <FormField
        label="Czas rozpoczęcia"
        name="startDate"
        type="datetime-local"
        value={variantData.startDate}
        onChange={handleChange}
        required
      />
      <FormField
        label="Czas zakończenia"
        name="endDate"
        type="datetime-local"
        value={variantData.endDate}
        onChange={handleChange}
        required
      />
      <FormField
        label="Opis wariantu"
        name="description"
        type="richtext"
        value={variantData.description}
        onChange={handleChange}
        placeholder="Szczegółowy opis wariantu"
      />
      <FormField
        label="Miejsce zbiórki"
        name="place"
        type="richtext"
        value={variantData.place}
        onChange={handleChange}
        placeholder="Podaj miejsce zbiórki"
      />
      <FormField
        label="Dojazd"
        name="transport"
        type="richtext"
        value={variantData.transport}
        onChange={handleChange}
        predefinedValues={[
          "Dojazd samodzielny samochodem. Po zebraniu się grupy będzie możliwość umówienia się na wspólny przejazd. Podczas zapisów daj nam znać, czy możesz być osobą kierującą i czy możesz zabrać dodatkowe osoby pasażerskie.",
          "Dojazd samodzielny samochodem lub transportem publicznym. Po zebraniu się grupy będzie okazja do umówienia się na wspólny przejazd. Możliwy jest również dojazd pociągiem/autobusem.",
          "Dojazd zorganizowany wynajętym autokarem.",
          "Dojazd samodzielny transportem publicznym."
        ]}
        placeholder="Domyślne wartości dostępne pod 📋"
      />
      <FormField
        label="Dodać pytanie o samochody?"
        name="askAboutCars"
        type="toggle"
        value={variantData.askAboutCars}
        onChange={handleChange}
      />
      <FormField
        label="Start zapisów"
        name="registrationStartDate"
        type="datetime-local"
        value={variantData.registrationStartDate}
        onChange={handleChange}
      />
      <FormField
        label="Koniec zapisów"
        name="registrationEndDate"
        type="datetime-local"
        value={variantData.registrationEndDate}
        onChange={handleChange}
        info="Zalecamy ustawienie końca zapisów na 72h (trzy dni) przed rozpoczęciem wycieczki. Dla wyjazdów bezpłatnych, termin ten może być krótszy."
      />
      <FormField
        label="Limit miejsc wariantu"
        name="capacity"
        type="text"
        disabled={true}
        value={findMinCapacityByVariant?.toString() || ""}
        info="Ustalany na podstawie minimum wszystkich przewidzianych miejsc w elementach powiązanych z wariantem."
        placeholder="Generowany automatycznie"
      />
      <FormField
        label="Czy jest to impreza turystyczna?"
        name="isTouristEvent"
        type="toggle"
        value={variantData.isTouristEvent}
        onChange={handleChange}
        info="Co najmniej dwie usługi turystyczne objęte jednolitym programem i wspólną ceną, podlega wymaganiom ustawowym. Jeśli jest to wyjazd specjalny (zamknięty), zaznacz “nie”."
      />

      {variantData.isTouristEvent && 
      <FormField 
        label="Składka na Turystyczny Fundusz Gwarancyjny"
        name="tfgContribution"
        type="number"
        unit="zł"
        step="0.01"
        min="0"
        value={variantData.tfgContribution?.toString() || ""}
        onChange={handleChange}
        required
      />}
      <FormField
        label="Czy jest to wycieczka zagraniczna?"
        name="isTripAbroad"
        type="toggle"
        value={variantData.isTripAbroad}
        onChange={handleChange}
      />
      {/* {variantData.isTouristEvent && !variantData.isTripAbroad && (
        <FormField
          label="Czy chcesz umożliwić osobom uczestniczącym wykupienie ubezpieczenia NNW?"
          name="askAboutNNW"
          type="toggle"
          value={variantData.askAboutNNW}
          onChange={handleChange}
        />
      )} */}

                  {/*variantData.askAboutNNW || */} 
      {variantData.isTouristEvent && (variantData.isTripAbroad) && (
        <>
         <FormField
            label="Kraj docelowy"
            name="destinationCountry"
            type="text"
            value={variantData.destinationCountry}
            onChange={handleChange}
            placeholder="Np. Czechy, Słowacja, Włochy..."
            required
          />
          <FormField
            label="Data przekroczenia granicy (wyjazd)"
            name="borderCrossingOutboundDate"
            type="date"
            value={formatDateOnly(variantData.borderCrossingOutboundDate)}
            onChange={handleChange}
            required
          />
          <FormField
            label="Data przekroczenia granicy (powrót)"
            name="borderCrossingReturnDate"
            type="date"
            value={formatDateOnly(variantData.borderCrossingReturnDate)}
            onChange={handleChange}
            required
          />

           <FormField type="label" label="Rodzaj ubezpieczenia NNW" required />
    <Select
    options={[
      { value: "rekreacyjne", label: "sport rekreacyjny - 6 zł/dzień" },
      { value: "zimowe", label: "sport zimowy/wodny - 8 zł/dzień" },
      { value: "wysokie", label: "sporty wysokiego ryzyka - 12 zł/dzień" },
    ]}
    value={
      [
      { value: "rekreacyjne", label: "sport rekreacyjny - 6 zł/dzień" },
      { value: "zimowe", label: "sport zimowy/wodny - 8 zł/dzień" },
      { value: "wysokie", label: "sporty wysokiego ryzyka - 12 zł/dzień" },
      ].find((opt) => opt.value === variantData.nnwRateType) || ""
    }
    onChange={(selected) => {
      const selectedValue = selected?.value || null;
      const rates = { rekreacyjne: 6, zimowe: 8, wysokie: 12 };
      const base = selectedValue ? rates[selectedValue] : 0;

      const start = new Date(variantData.borderCrossingOutboundDate);
      const end = new Date(variantData.borderCrossingReturnDate);

      const diffDays =
        !isNaN(start) && !isNaN(end)
          ? Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
          : 0;

      const total = base * diffDays;

      setVariantData((prev) => ({
        ...prev,
        nnwRateType: selectedValue,
        nnwContribution: total ? total.toFixed(2) : null,
      }));
    }}
    isClearable
    placeholder="Wybierz rodzaj ubezpieczenia"
    isSearchable
    styles={{
      container: (base) => ({
        ...base,
        width: "100%",
      }),
      control: (base) => ({
        ...base,
        width: "100%",
        marginTop: "-20px",
        marginBottom: "20px",
      }),
    }}
  />

  {variantData.borderCrossingOutboundDate &&
    variantData.borderCrossingReturnDate &&
    variantData.nnwRateType && (
      <small style={{ color: "#555", marginLeft: "2px" }}>
        Dni:{" "}
        {
          Math.floor(
            (new Date(variantData.borderCrossingReturnDate) -
              new Date(variantData.borderCrossingOutboundDate)) /
              (1000 * 60 * 60 * 24)
          ) + 1
        }{" "}
        • Stawka: {({ rekreacyjne: 6, zimowe: 8, wysokie: 12 }[
          variantData.nnwRateType
        ])}{" "}
        zł/dzień
      </small>
    )}

  <FormField
    label="Wysokość składki NNW"
    name="nnwContribution"
    type="number"
    unit="zł"
    value={variantData.nnwContribution?.toString() || ""}
    onChange={handleChange}
    min={0}
    step={0.01}
    required
    disabled
  />
 

         <FormField
            label="Wysokość składki NNW od kosztów rezygnacji"
            name="nnwResignationCostContribution"
            type="number"
            unit="zł"
            value={resignationInsuranceAmount.toString()}
            disabled={true}
            info={`Wynosi 2,2% od bazowej ceny imprezy: suma elementów (${variantElementsTotal} zł) + koszty administracyjne (${variantData.administrativeCosts ?? 0} zł)`}
            placeholder="Generowana automatycznie"
          />
        </>
      )}

      <FormField
        label="Koszty administracyjne"
        name="administrativeCosts"
        type="number"
        step="0.01"
        min="0"
        value={variantData.administrativeCosts?.toString() || ""}
        onChange={handleChange}
        unit="zł"
        info="Ustalona domyślna wartość 6 zł"
      />

      <FormField
        label="Procent przedpłaty"
        name="prepaymentPercentage"
        type="number"
        step="1"
        min="0"
        max="100"
        value={variantData.prepaymentPercentage?.toString() || ""}
        onChange={handleChange}
        unit="%"
        required
      />
        <FormField
          label="Cena wariantu"
          name="variantPrice"
          type="text"
          info={`Wyliczana jako: suma elementów (${variantElementsTotal} zł) + koszty administracyjne (${variantData.administrativeCosts ?? 0} zł)` +
                (variantData.isTouristEvent ? ` + składka TFG (${variantData.tfgContribution ?? 0} zł)` : '') +
                (variantData.isTouristEvent && variantData.isTripAbroad ? ` + NNW (${variantData.nnwContribution ?? 0} zł)` : '')}
          disabled={true}
          placeholder="Wyliczana automatycznie"
          value={fullPrice.toString()}
        />

      <FormField
        label="Kwota przedpłaty"
        name="prepaymentPrice"
        type="text"
        disabled={true}
        placeholder="Generowana automatycznie"
        info={`Wyliczana ze wzoru: 
          suma elementów (${variantElementsTotal}) * ${variantData.prepaymentPercentage ?? 100}% + pozostałe koszty (${additionalCosts}) = ${prepaymentAmount} zł`}
        value={prepaymentAmount.toString()}
      />

      <FormField
        label="Termin płatności"
        name="finalPaymentDate"
        type="datetime-local"
        info="Ostateczny termin płatności całej ceny. Jeśli nie wskażesz terminu płatności, w formularzu będzie widniała informacja, że wpłat można dokonywać najpóźniej trzy dni przed rozpoczęciem wydarzenia."
        value={variantData.finalPaymentDate}
        onChange={handleChange}
      />
      
      <FormField
        label="Cena zawiera"
        name="priceIncludes"
        type="richtext"
        value={variantData.priceIncludes}
        onChange={handleChange}
        required={variantData.isTouristEvent}
        placeholder="* Wyżywienie; * Zakwaterowanie, etc..."
      />
      <FormField
        label="Cena nie zawiera"
        name="priceNotIncludes"
        type="richtext"
        value={variantData.priceNotIncludes}
        onChange={handleChange}
        required={variantData.isTouristEvent}
        placeholder="* Wyżywienie; * Zakwaterowanie, etc..."
      />
      <FormField
        label="Czy zwierzęta dozwolone?"
        name="petsAllowed"
        type="toggle"
        value={variantData.petsAllowed}
        onChange={handleChange}
      />
      <FormField
        label="Informacja o zwierzętach"
        name="petsInfo"
        type="textarea"
        value={variantData.petsInfo}
        onChange={handleChange}
        predefinedValues={[
          "Na to wydarzenie niestety nie można zabrać piesków",
          "Na to wydarzenie zapraszamy z pieskami. Należy mieć przy sobie aktualny dowód szczepienia na wściekliznę."
        ]}
      />

      <FormField
        label="Dodać pytanie o wariant wyżywienia?"
        name="askAboutFoodOptions"
        type="toggle"
        value={variantData.askAboutFoodOptions}
        onChange={handleChange}
        info={"Opcja ta pojawi się przy dokonywaniu rezerwacji na wycieczkę."}
      />

      {variantData.askAboutFoodOptions && (
              <FormField
                label="Informacje o wyżywieniu"
                name="foodInfo"
                type="textarea"
                value={variantData.foodInfo}
                onChange={handleChange}
                placeholder="Jaki wariant wyżywienia do wyboru, specjalne potrzeby żywieniowe, etc."
                info="Informacja wyświetlająca się osobie uczestniczącej, w trakcie tworzenia rezerwacji."
            />
            )}

      
      <FormField
        label="Dodatkowe informacje"
        name="additionalInfo"
        type="richtext"
        value={variantData.additionalInfo}
        onChange={handleChange}
              />

      <FormField 
        label="Informacje dla osób o ograniczonej sprawności ruchowej"
        name="peopleWithDisabilitiesInfo"
        type="richtext"
        value={variantData.peopleWithDisabilitiesInfo}
        onChange={handleChange}
        predefinedValues={[
          `Wydarzenie nie jest dostosowane do potrzeb osób o ograniczonej sprawności ruchowej. W sprawie możliwości dostosowania go do Twoich potrzeb skontaktuj się z osobą koordynującą wycieczkę: ${user.email}`
        ]}
        required={variantData.isTouristEvent}
        />
      <FormField
        label="Wymagania językowe"
        name="languageRequirements"
        type="richtext"
        value={variantData.languageRequirements}
        onChange={handleChange}
        predefinedValues={[
          `Komunikacja będzie prowadzona w języku polskim. Osoba koordynująca posługuje się również językiem angielskim.`
        ]}
        required={variantData.isTouristEvent}
      />
      <FormField
        label="Wymagane dokumenty"
        name="requiredDocuments"
        type="richtext"
        value={variantData.requiredDocuments}
        onChange={handleChange}
        required={variantData.isTouristEvent}
        predefinedValues={[
          "Dowód osobisty lub paszport"
        ]}
      />
      {variantData.isTouristEvent && <FormField
        label="Miejsce lub skrócona trasa (nie wyświetlany na formularzu)"
        name="shortenedPlaceName"
        type="textarea"
        value={variantData.shortenedPlaceName}
        onChange={handleChange}
        required
      />}
        {variantData.isTouristEvent && <FormField
        label="Minimalna liczba zgłoszeń"
        name="minRegistrationsNumber"
        type="number"
        value={variantData.minRegistrationsNumber?.toString() || ""}
        onChange={handleChange}
        required
        step="1"
        min="0"
      /> 
      } 
      { variantData.isTouristEvent && <FormField
        label="Maksymalny termin odwołania wycieczki"
        name="cancelationTripFinalDate"
        type="date"
        value={formatDateOnly(variantData.cancelationTripFinalDate)}
        onChange={handleChange}
        info={getSuggestedCancellationInfoText(variantData.startDate, variantData.endDate)}
        required
      /> 
      }
      <FormField
        label="Ubezpieczenie"
        name="insuranceDetails"
        type="richtext"
        value={variantData.insuranceDetails}
        onChange={handleChange}
        required={variantData.isTouristEvent}
        predefinedValues={[
          "Zalecamy indywidualne wykupienie ubezpieczenia NNW i kosztów ratownictwa.",
          "W cenie zawarte jest podstawowe zagraniczne (nie obowiązuje w Polsce) ubezpieczenie NNW, kosztów ratownictwa oraz OC. Możliwe jest wykupienie dodatkowego ubezpieczenia kosztów rezygnacji. Szczegóły poznasz w następnym kroku."
        ]}
      />
      </>)}
    



    {!showElementInForm && (
        <div className="elementsSection">
          <div className="elementsHeader">
            <div className="elementsHeaderTitle"><div>Elementy:</div></div>
            {variantData.guid && (
              <div
                className="addElementButton"
                onClick={handleAddElement}
                aria-label="Dodaj element"
              >
                <i className={`fas fa-plus addElementIcon`}></i>
              </div>
            )}
          </div>

          {Object.keys(groupedElementsByDay).length === 0 ? (
            <div className="noElementsMessage">
              <em><div>{variantData.guid ? "Brak dodanych elementów. Kliknij ikonę + po prawej stronie, aby dodać nowy element." : "Aby dodać elementy do nowego wariantu, musisz najpierw go utworzyć."}</div></em>
            </div>
          ) : (
            <div className="elementsList">
            {Object.entries(groupedElementsByDay).map(([dayLabel, elements]) => (
              <div key={dayLabel} className="elementsGroup">
                <h4 className="dayGroupHeader">{dayLabel}</h4>
                {elements.map((el) => (
                  <div
                    key={el.guid}
                    className="elementSummary"
                    onClick={() => handleEditElement(el)}
                    style={{ position: 'relative', cursor: 'pointer' }}
                  >
                    <div className="iconContainer">{typeIcons[el.type]}</div>
                    <div className="elementContent">
                      <div className="elementName"><strong><div>{el.name}</div></strong></div>
                      <div className="elementDate"><div>{formatDateWithTime(el.startDate)}</div></div>
                    </div>
                    {el.variants.length > 1 && (
                      <span className="linkedElementIcon" title="Element powiązany z innymi wariantami">🔗</span>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>

          )}
        </div>
      )}

      {showElementInForm && (
        <Element
          onSave={saveElement}
          onCancel={cancelElement}
          onDelete={onClickDeleteElement}
          initialData={clickedElement}
          variantGuid={variantData.guid}
        />
      )}

      {!clickedElement && !showElementInForm && (
        <div className="actions">
          {!variantData.guid ? (
            <>
              <button
                className="btnSecondary"
                onClick={handleDiscardChanges}
              >
                <div>Odrzuć Zmiany</div>
              </button>
              <button
                className="btnPrimary"
                onClick={handleSaveVariant}
                disabled={isSaving}
              >
                <div>{isSaving ?   <> <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }} />Zapisywanie...</> : 'Utwórz Wariant'}</div>
              </button>
            </>
          ) : (
            <>
              <button
                className="btnDanger"
                onClick={handleDeleteVariant}
                disabled={isDeleting}
              >
                <div>{isDeleting ?  <> <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }} />Usuwanie...</>  : "Usuń Wariant"}</div>
              </button>
              <button
                className="btnSecondary"
                onClick={handleDiscardChanges}
              >
                <div>Odrzuć Zmiany</div>
              </button>
              <button
                className="btnPrimary"
                onClick={handleSaveVariant}
                disabled={isSaving}
              >
                <div>{isSaving ?  <> <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }} />Zapisywanie...</>  : 'Zapisz Wariant'}</div>
              </button>
            </>
          )}
        </div>
      )}
      {showElementCreationChoice && (
        <div className="popup">
          <div className="popupContent nicePopup">

            <div className="popupHeader">
              <h3 className="popupTitle">Dodaj element</h3>
                           <div
              className="closeBtn"
              onClick={() => setShowElementCreationChoice(false)}
              aria-label="Zamknij"
            >
              &times;
            </div>
            </div>


            <div
              className="btnPrimary"
              onClick={() => {
                setClickedElement(null);
                setShowElementInForm(true);
                setShowElementCreationChoice(false);
              }}
            >
              <i className="fas fa-plus"></i>
              Nowy element
            </div>

            <div className="popupSeparator">lub</div>


             <div className="variant-element-desc"><i className="fa-regular fa-copy copyIcon" /> Skopiuj z istniejącego elementu:</div>
            {Object.entries(getElementsGroupedByVariant()).map(([variantName, elements]) => {
              const isExpanded = expandedCopyGroup === variantName;

              return (
                <div key={variantName} className="copyGroup">
                  <div
                    className="variantGroupTitle copyGroupHeader"
                    onClick={() => toggleCopyGroup(variantName)}
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    <div>{variantName}</div>
                    <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`} />
                  </div>

                  {isExpanded && (
                    <div className="copyList">
                      {elements.map((el) => (
                        <div
                          key={el.guid}
                          className="copyItem"
                          onClick={() => {
                            const copied = {
                              ...el,
                              variants: [],
                              guid: undefined,
                              name: el.name,
                            };
                            setClickedElement(copied);
                            setShowElementInForm(true);
                            setShowElementCreationChoice(false);
                          }}
                        >
                           {el.name} – {formatDateWithTime(el.startDate)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}

          </div>
        </div>
      )}



    </div>
    
  );
};

export default Variant;
